import { BackgroundOperationType } from 'enums/BackgroundOperationStatus';
import { BackgroundOperationData } from 'interfaces/BackgroundOperation';
import { randomUuid } from 'utils/random';

export const enum BackgroundOperationActionType {
    Start = 'BACKGROUND_OPERATION/START',
    Update = 'BACKGROUND_OPERATION/UPDATE',
    Finish = 'BACKGROUND_OPERATION/FINISH',
    Cancel = 'BACKGROUND_OPERATION/CANCEL',
    Remove = 'BACKGROUND_OPERATION/REMOVE',
}

export type StartBackgroundOperationAction = ReturnType<typeof startBackgroundOperation>;
export const startBackgroundOperation = (title: string, type?: BackgroundOperationType) => ({
    type: BackgroundOperationActionType.Start,
    payload: {
        uuid: randomUuid(),
        title,
        type,
        progress: 0,
    } as BackgroundOperationData,
});

export type UpdateBackgroundOperationAction = ReturnType<typeof updateBackgroundOperation>;
export const updateBackgroundOperation = (uuid: string, name: string, progress: number) => ({
    type: BackgroundOperationActionType.Update,
    payload: { uuid, title: name, progress } as BackgroundOperationData,
});

export type FinishBackgroundOperationAction = ReturnType<typeof finishBackgroundOperation>;
export const finishBackgroundOperation = (uuid: string) => ({
    type: BackgroundOperationActionType.Finish,
    payload: uuid,
});

export type CancelBackgroundOperationAction = ReturnType<typeof cancelBackgroundOperation>;
export const cancelBackgroundOperation = (uuid: string) => ({
    type: BackgroundOperationActionType.Cancel,
    payload: uuid,
});

export type RemoveBackgroundOperationAction = ReturnType<typeof removeBackgroundOperation>;
export const removeBackgroundOperation = (uuid: string) => ({
    type: BackgroundOperationActionType.Remove,
    payload: uuid,
});
